import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_SMART_IMAGE_BANDITS_V2 = defineFcm('starfish_smart_image_bandits_v2')
	.asBoolean()
	.withDefault(false)
	.toConfig();
